module.exports = __webpack_public_path__ + "img/main_home2.1400c17.png";